<template>
<div>

    <v-dialog v-model="dialog" persistent max-width="750" scrollable>
        <v-card>
            <v-card-title class="text-h5 pl-6 font-weight-regular">{{id?'Edit':'Add'}} Service Provider
                <v-spacer/><v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title><v-divider/>
            <v-card-text class="mt-4">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="6" class="pb-0">
                            <v-row>
                            <v-col cols="12" class="pt-0">
                                <label class="text-uppercase grey--text font-weight-bold">Service Category*</label>
                                <v-autocomplete outlined  class="mt-3" :items="serviceCategories"
                                                :rules="[v => !!v || 'Service Category Required']"
                                                v-model="form.serviceCategoryId" item-text="name" item-value="id"/>
                            </v-col>
                            <v-col cols="12" class="pt-0">
                                <label class="text-uppercase grey--text font-weight-bold">Is Chargeable ?</label>
                                <v-switch class="mt-3" inset v-model="form.isChargeable"/>
                            </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="6">
                            <label class="text-uppercase grey--text font-weight-bold">Image*</label>
                            <input id="file-provider" @change="onSelectFile" type="file" accept="image/*, .jfif" v-if="dialog" style="display: none"/>
                            <div class="image-div mt-3" @click="openFile">
                                <ImageBox :imageLoading="imageLoading" :imageUrl="form.image"/>
                            </div>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Company Name*</label>
                            <v-text-field outlined v-model="form.companyName" class="mt-3"
                                          :rules="[v => !!v || 'Company Name Required']"/>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Person Name</label>
                            <v-text-field outlined v-model="form.personName" class="mt-3"/>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Mobile*</label>
                            <v-text-field type="number" outlined v-model="form.mobile" class="mt-3"
                                          :rules="[v => !!v || 'Mobile Required',v => v && v.length === 10 || 'Must be 10 characters']"/>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">WhatsApp Number*</label>
                            <v-text-field type="number" outlined v-model="form.whatsappNumber" class="mt-3"
                                          :rules="[v => !!v || 'WhatsApp Number Required',v => v && v.length === 10 || 'Must be 10 characters']"/>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">City*</label>
                            <v-autocomplete outlined  class="mt-3" :items="cities" :search-input.sync="searchCity"
                                            :rules="[v => !!v || 'City Required']" v-model="form.city" @change="onSelectCity"
                                            item-text="name" return-object :loading="$apollo.queries.cities.loading"/>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">State*</label>
                            <v-text-field outlined v-model="form.state" class="mt-3" :rules="[v => !!v || 'State Required']"/>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Experience (in years)*</label>
                            <v-text-field type="number" outlined v-model="form.experience" class="mt-3"
                                          :rules="[v => !!v || 'Experience Required', v => v>0 || 'Invalid Value']"/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <v-btn class="text-capitalize elevation-0 mr-2" @click="closeDialog">Cancel</v-btn>
                <v-btn class="primary px-3 text-capitalize" :loading="formLoading" dark @click="handleSubmit">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <Snackbar :toaster="toaster"/>
</div>
</template>

<script>
import Constants from "../../Constants/Constants";
import moment from 'moment';
import Snackbar from "../../components/Common/Snackbar";
import ImageBox from "../../components/Common/ImageBox";
import NetworkCommunicator from "../../plugins/NetworkResourceHandler";
import {GET_SERVICE_PROVIDER_BY_ID} from "../../graphql/queries/ServiceProviders";
import {CREATE_UPDATE_SERVICE_PROVIDER} from "../../graphql/mutations/ServiceProviders";
import {GET_SERVICE_CATEGORIES} from "../../graphql/queries/ServiceCategories";
import {GET_ALL_CITIES} from "../../graphql/queries/Territories";
import {debounce} from "lodash";
let user = JSON.parse(localStorage.user);
let form = { serviceCategoryId:'', companyName:'', personName:null, image:'', mobile:'', whatsappNumber:'',
    city:'', state:'', experience:'', isChargeable:false, createdBy:user.id, updatedBy:user.id };

export default {
    name: "ServiceProviderForm",
    components: {ImageBox, Snackbar},
    props: ['dialog', 'id'],
    apollo: {
        ServiceProviders: {
            query: GET_SERVICE_PROVIDER_BY_ID,          //Always fetch createdBy to override default
            fetchPolicy: 'network-only',
            skip () {return !this.id},
            variables(){ return{ id: this.id } },
            result ({data}) {
                Object.copyExistingKeys(this.form = {...form, id:''}, data.ServiceProviders[0]);
                this.filterCity = this.form.city;
            },
        },
        serviceCategories: {
            query: GET_SERVICE_CATEGORIES,
            fetchPolicy: 'network-only',
            skip () {return !this.dialog},
        },
        cities: {
            query: GET_ALL_CITIES,
            variables(){ return{ city: '%' +this.filterCity+ '%' } }
        },
    },
    data(){
        return{
            moment: moment,
            Constants: Constants,
            form: {...form},
            formLoading: false, imageLoading: false,
            serviceCategories: [],
            cities: [], searchCity: null, filterCity: null,
            toaster: {enable: false}
        }
    },
    watch: {
        searchCity: debounce(function(val) {
            if(val?.length > 1) this.filterCity = val
        }, 500)
    },
    methods:{
        onSelectCity(val){
            this.form.state = val.StateName;
            this.form.city = val.name;
        },
        openFile(){
            document.getElementById('file-provider').click();
        },
        onSelectFile(evt){
            this.imageLoading = true;
            let file = evt.target.files[0];
            if(!file) return this.imageLoading = false;
            let formData = new FormData();
            formData.append('image', file);
            formData.append('name', file.name);
            NetworkCommunicator('POST', Constants.api_url + 'v1/upload', formData).then(res => {
                if(res.flag) this.form.image = res.data;
                else this.toaster = {enable:true, color:'red', message: 'Image Upload Failed'};
                this.imageLoading = false
            }).catch(function(err){
                console.log('Upload File Error', err)
                this.toaster = {enable:true, color:'red', message: 'Image Upload Failed'}
                this.imageLoading = false
            })
        },
        handleSubmit(){
            if(this.$refs.form.validate() && this.form.image)
                this.saveServiceProvider()
            else if(this.$refs.form.validate() && !this.form.image)
                this.toaster = {color: 'red', enable:true, message: 'Please attach Image'}
        },
        async saveServiceProvider(){
            this.formLoading = true;
            let response = await this.$apollo.mutate({
                mutation: CREATE_UPDATE_SERVICE_PROVIDER,
                variables: {
                    serviceProvider: { ...this.form },
                    updateColumns: [...Object.keys(this.form)],
                }
            });
            if(response.data){
                this.formLoading = false;
                this.toaster = {enable:true, color:'green', message: `Service Provider saved Successfully`};
                this.closeDialog();
            }
        },
        closeDialog(){
            this.$refs.form.resetValidation();
            this.form = {...form};
            this.$emit('update:dialog', false);
            this.$emit('update:id', null);
        }
    }
}
</script>

<style scoped>
    .image-div{
        width: 330px;
        height: 160px;
        /*margin: auto;*/
    }
</style>